import DialogContext from './DialogContext';
import DialogProvider from './DialogProvider';

export default {
  Consumer: DialogContext.Consumer,
  Provider: DialogProvider
};
